import { gsap } from './gsap';

export function initReveal() {
    initImageReveal();
}

function initImageReveal() {
    document.querySelectorAll( '[data-reveal]' ).forEach( ( el ) => {
        gsap.from( el, { opacity: 0, duration: 1.2, ease: 'power2.out', delay: 0.1 } );
    } );
}
